export enum MESSAGES {
  Required = "Обязательное поле",
  CardNumber = "Неверный формат номера банковской карты",
  CardExpiration = "Неверный формат срока действия банковской карты",
  CardCVV = "CVV код должен состоять минимум из 3 цифр",
  CardName = "Неверный формат имени карты, введите заглавными латинскими буквами как на карте",
  Email = "Неверный формат email",
  Password = "Более 5 знаков, включая заглавные и строчные латинские буквы, цифры и специальные символы",
  PasswordMismatch = "Пароли не совпадают",
}
